function moveDescriptionBelowCTA() {
    const isMobile = window.innerWidth <= 768;
    const description = document.querySelector('.column-left .product-description.rte.cf');
    const buyButtons = document.querySelector('.product-extra-info');

    if (isMobile && description && buyButtons) {
        // Sposta la descrizione dopo i buy-buttons
        buyButtons.parentNode.insertBefore(description, buyButtons.nextSibling);
    }
}

// Esegui al caricamento della pagina
window.addEventListener('load', moveDescriptionBelowCTA);

// Esegui al ridimensionamento della finestra per gestire il cambio da desktop a mobile
window.addEventListener('resize', moveDescriptionBelowCTA);